import api from "./axiosConfig";

/**
 * Baixa um arquivo via endpoint blob (mesma mecânica dos anexos de audiência).
 */
export async function downloadBlobFile(
  url: string,
  fileName: string
): Promise<void> {
  const response = await api.get(url, { responseType: "blob" });
  const objectUrl = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}
